import axiosConfig from '@lib/axiosConfig';


export const OmbudsmanOriginService = {

    list: async function () {
        return await axiosConfig.get('/ombudsman-origins');
    },

    show: async function (id) {
        return await axiosConfig.get(`/ombudsman-origins/show/${id}`);
    },

    fetchbyfilter: async function (filter, order=null, limit=null) {
        return await axiosConfig.get(`/ombudsman-origins/fetchbyfilter/${filter}/${order}/${limit}`);
    },

    store: async function (data) {
        return await axiosConfig.post('/ombudsman-origins/store', data);
    },

    update: async function (data, id) {
        return await axiosConfig.put(`/ombudsman-origins/update/${id}`, data);
    },

    delete: async function (id) {
        return await axiosConfig.delete(`/ombudsman-origins/delete/${id}`);
    },

};